import {Card, CardContent, CardMedia, CardProps, Stack, Typography} from "@mui/material";
import {WorkClassDocument} from "../../../../types/pj1dbApiWork";
import {pickImageUrl} from "../../../../utils/workUtil";
import {MODEL_BG_COLOR, WORK_ATTRS} from "../../../../constants/work";

export interface WorkListItemProps extends CardProps {
  item: WorkClassDocument;
}

export default function WorkClassListItem({item, ...props}: WorkListItemProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Card {...props} sx={{p: 0, m: 0, width: 240, height: '100%', ...props.sx}}>
      <CardMedia
        component="img"
        height="145"
        image={pickImageUrl(item)}
        alt={item.attr[WORK_ATTRS.nameJp.key]}
        sx={{objectFit: "scale-down", backgroundColor: MODEL_BG_COLOR}}
      />
      <CardContent sx={{pt: 1, px: 1, textWrap: 'nowrap', overflowX: 'scroll'}}>
        <Stack gap={1}>
          <Typography variant="subtitle2" component='p'>
            対象物名：<br/>
            {item.attr[WORK_ATTRS.nameJp.key] ?? '　'}
          </Typography>
          <Typography variant="subtitle2" component='p' sx={{color: "#888"}}>
            JANコード/部品コード：<br/>
            {item.attr[WORK_ATTRS.code.key] ?? '　'}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  )
}
